import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CMEWorkload } from "../cme-util/cme-utils";
import { getLastUpdatedDateColor, getLastUpdatedTootlTip } from "../../dashboard-util/dashboard-utils";
import { Modal } from "react-bootstrap";
import "../../dashboard-cme/dashboard-cme.scss";

const CMEGroupHeadMemberModal = (props) => {
    const [projectsMembers, setProjectsMembers] = useState(props.item.ProjectMembers ? props.item.ProjectMembers : null);

    useEffect(() => {
        if (props.item.ProjectMembers) setProjectsMembers(props.item.ProjectMembers);
    }, [props]);

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            contentClassName="dashboard-modal-styles"
            dialogClassName="dashboard-modal"
            scrollable={true}
            data-testid="modal"
        >
            <Modal.Header
                className="dashboard-modal-header"
                closeButton
                data-testid="modal-header"
            >
                <Modal.Title className="dashboard-modal-title ml-4" data-testid="modal-title">
                    {(props.item.ProjectDynamicFields?.[0]?.Data ?? "No Data")} &middot; {props.item.Project?.Name}
                    <p className="subDepartmentTitle">Deal Tracker</p>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="cmeModalBody" data-testid="modal-body">
                <table className="CMEDashboard" data-testid="project-table">
                    <thead className="MemberTableColumnHeader cmeHeader">
                        <tr className="tableColumnTitles tableHeader">
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Analyst/Associate</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">M-F Hours</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Saturday Hours</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Sunday Hours</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Total Hours</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Workload</th>
                            {getLastUpdatedTootlTip(<th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Updated</th>)}
                        </tr>
                    </thead>
                    <tbody className="tableBody cmeBody">
                        {projectsMembers.length > 0 &&
                            projectsMembers?.map((pm) => {
                                return (
                                    <tr key={pm.UserId} data-testid={`project-${pm.UserId}`}>
                                        <td className="col-md-1 col-sm-1 mt-2 ">
                                            <div className="violationContainer">
                                                {pm.AnalystAssociate}
                                            </div>
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.MFHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.SaturdayHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.SundayHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.TotalHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            <CMEWorkload workload={pm.Workload} />
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2" style={{ color: getLastUpdatedDateColor(pm.LastUpdated) }}>
                                            {pm.LastUpdated ?? "-"}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </Modal.Body>
        </Modal>
    );
};

CMEGroupHeadMemberModal.propTypes = {
    item: PropTypes.shape({
        ProjectMembers: PropTypes.arrayOf(PropTypes.shape({
            UserId: PropTypes.string,
            IsViolation: PropTypes.bool,
            AnalystAssociate: PropTypes.string,
            MFHours: PropTypes.string,
            SaturdayHours: PropTypes.string,
            SundayHours: PropTypes.string,
            TotalHours: PropTypes.string,
            Workload: PropTypes.string,
            LastUpdated: PropTypes.string
        })),
        ProjectDynamicFields: PropTypes.arrayOf(PropTypes.shape({
            Data: PropTypes.string
        })),
        Project: PropTypes.shape({
            Name: PropTypes.string
        })
    }),
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired
};

CMEGroupHeadMemberModal.defaultProps = {
    item: {
        ProjectMembers: [],
        ProjectDynamicFields: [],
        Project: null,
    }
};

export default CMEGroupHeadMemberModal;